import { createContext, useContext } from 'react';

export type FanforgeConfig = {
  allowDeviceLogin: boolean;
  platformApiUrl: string;
  postHogHost: string;
  postHogKey: string;
  assetsUrl: string;
  mode: 'development' | 'staging' | 'production' | 'unknown' | 'test';
};

type FanforgeConfigProviderProps = {
  children: React.ReactNode;
  config: FanforgeConfig;
};

export const FanforgeConfigContext = createContext<FanforgeConfig | null>(null);

export const FanforgeConfigProvider = ({ children, config }: FanforgeConfigProviderProps) => {
  return <FanforgeConfigContext.Provider value={config}>{children}</FanforgeConfigContext.Provider>;
};

export function useFanforgeConfigs() {
  const config = useContext(FanforgeConfigContext);
  if (!config) {
    throw new Error('useFanforgeConfigs must be used within FanforgeConfigProvider');
  }
  return config;
}

export * from './user-settings-provider';
